import React from "react";
import { useAuth } from "../hooks/useAuth";
import { canAccess } from "../utils/permissions";
import EstimateList from "../components/costs/EstimateList";

const CostsPageWrapper = () => {
  const { user, loading: authLoading } = useAuth();

  if (authLoading) {
    return <div className="loading">Wird geladen...</div>;
  }

  if (!user || !canAccess(user, "kostenschaetzung")) {
    return (
      <div className="access-denied">
        <h3>Zugriff verweigert</h3>
        <p>Sie haben keine Berechtigung für diesen Bereich.</p>
      </div>
    );
  }

  return <EstimateList />;
};

export default CostsPageWrapper;
